/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="108"
    viewBox="0 0 108 108"
    width="108"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <filter
      id="a"
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
      height="108"
      width="108"
      x="0"
      y="0"
    >
      <feFlood floodOpacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="5" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
    </filter>
    <g filter="url(#a)">
      <rect height="88" rx="16" width="88" x="10" y="8" />
      <g strokeWidth="2">
        <path d="m69 43c0-7.732-6.4919-14-14.5-14s-14.5 6.268-14.5 14" />
        <path d="m42 58.2609c-6.0751 0-11-3.6401-11-8.1305 0-4.4903 2.5336-8.1304 8.6087-8.1304" />
        <path d="m66.5 58.2609c6.0751 0 11-3.6401 11-8.1305 0-4.4903-2.5336-8.1304-8.6087-8.1304" />
        <path
          d="m74 71v-5.5c0-1.1046-.8954-2-2-2h-11c-1.1046 0-2-.8954-2-2v-2.5"
          strokeLinecap="round"
        />
        <path
          d="m33 71v-5.5c0-1.1046.8954-2 2-2h12c1.1046 0 2-.8954 2-2v-2.5"
          strokeLinecap="round"
        />
        <circle cx="54" cy="73" r="2" transform="matrix(-1 0 0 -1 108 146)" />
        <circle cx="74" cy="73" r="2" transform="matrix(-1 0 0 -1 148 146)" />
        <circle r="2" transform="matrix(1 .00000009 .00000009 -1 33 73)" />
        <path d="m54 71v-12" strokeLinecap="round" />
        <ellipse cx="54" cy="46" rx="9" ry="7" />
        <path d="m48 41c0-3.866 2.6863-7 6-7s6 3.134 6 7" />
        <circle cx="54" cy="45" r="2" />
        <path d="m54 50v-3" strokeLinecap="round" />
      </g>
    </g>
  </svg>
);
